import React from "react";

interface ISubmitButtonProps {
  onSubmit: VoidFunction;
  buttonText: string;
  loading?: boolean;
}

export default function SubmitButton({
  onSubmit,
  buttonText,
  loading
}: ISubmitButtonProps) {
  return (
    <button
      className={`ch-btn ch-btn--success ch-display--flex ch-mt--4 ch-mb--4 sm:ch-width--5 md:ch-width--4 ch-width--12 ${
        loading ? "ch-btn--loading" : ""
      }`}
      type="button"
      onClick={onSubmit}
    >
      {buttonText}
    </button>
  );
}
